import type { PartnerSessionMetadata } from '@utils/partnerSession';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface PartnerSessionState {
  partnerSession: PartnerSessionMetadata | null;
}

const initialState: PartnerSessionState = {
  partnerSession: null,
};

const partnerSessionSlice = createSlice({
  name: 'partnerSession',
  initialState,
  reducers: {
    setPartnerSession: (
      state,
      action: PayloadAction<PartnerSessionMetadata>,
    ) => {
      state.partnerSession = {
        partnerId: action.payload.partnerId,
        source: action.payload.source,
        city: action.payload.city,
        notes: action.payload.notes,
      };
    },
    clearPartnerSession: (state) => {
      state.partnerSession = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) =>
        [
          'login/resetStep',
          'sendOtp/fulfilled',
          'verifyOtp/fulfilled',
        ].includes(action.type),
      (state) => {
        state.partnerSession = null;
      },
    );
  },
});

export const { setPartnerSession, clearPartnerSession } =
  partnerSessionSlice.actions;

export default partnerSessionSlice.reducer;
